export function isProgressiveWebApp() {
  // For Android / Modern browsers
  return window.matchMedia('(display-mode: standalone)').matches;

  // Fallback for older iOS versions
  if (window.navigator.standalone){ return true };
}
